export default __webpack_public_path__ + "static/media/bg-box1.68bacf99.png";